import React, { useState, useEffect } from 'react'
import { FAQ, KnowledgeBase } from './AccordionData';
import Accordion from '../../components/Accordion/Accordion';
import AdvisorCard from '../../components/AdvisorCard/AdvisorCard';
import Button from '../../components/Button/Button'
import { HelpCircle, BookOpen, Grid, Search, ArrowRight, ChevronLeft, ChevronRight } from 'react-feather';
import styles from "./ConsumerDashboard.module.scss";
import advisorProfileService from '../../services/advisorProfile.service';
import { useNavigate } from 'react-router';
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom"
import GlobalFooter from '../../components/GlobalFooter/GlobalFooter'

function ConsumerDashboard(props) {

    const navigate = useNavigate();
    const [currentAdvisorsIndex, setCurrentAdvisorsIndex] = useState(0);
    const [featuredAdvisors, setFeaturedAdvisors] = useState([])
    const [loading, setLoading] = useState(true);

    // const [advisors, setAdvisors] = useState([featuredAdvisors.slice(0, 3), featuredAdvisors.slice(3, 6), featuredAdvisors.slice(6, 9), featuredAdvisors.slice(9, 12)])
    const [advisors, setAdvisors] = useState([])

    const changeFeaturedAdvisors = (direction) => {
        if (direction === "-") {
            setCurrentAdvisorsIndex(currentAdvisorsIndex === 0 ? (advisors.length - 1) : currentAdvisorsIndex - 1)
        } else {
            setCurrentAdvisorsIndex(currentAdvisorsIndex === (advisors.length - 1) ? 0 : currentAdvisorsIndex + 1)
        }
    }

    useEffect(() => {
        if (advisors.length > 0) {
            const handleResize = () => {
                if ((window.innerWidth > 1800) && advisors.length !== 3) {
                    setCurrentAdvisorsIndex(0)
                    setAdvisors([featuredAdvisors.slice(0, 4), featuredAdvisors.slice(4, 8), featuredAdvisors.slice(8, 12)])
                }
                if (((window.innerWidth > 1200) && (window.innerWidth < 1800)) && advisors.length !== 4) {
                    setCurrentAdvisorsIndex(0)
                    setAdvisors([featuredAdvisors.slice(0, 3), featuredAdvisors.slice(3, 6), featuredAdvisors.slice(6, 9), featuredAdvisors.slice(9, 12)])
                }

                if (((window.innerWidth < 1200) && (window.innerWidth > 820)) && advisors.length !== 6) {
                    setCurrentAdvisorsIndex(0)
                    setAdvisors([featuredAdvisors.slice(0, 2), featuredAdvisors.slice(2, 4), featuredAdvisors.slice(4, 6), featuredAdvisors.slice(6, 8), featuredAdvisors.slice(8, 10), featuredAdvisors.slice(10, 12)])
                }

                if (window.innerWidth <= 820 && advisors.length !== 12) {
                    setAdvisors(featuredAdvisors.map(advisor => [advisor]))
                }
            }


            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }

    }, [advisors])

    useEffect(async () => {
        setLoading(true);
        await fetchAdvisors();
        setLoading(false);
    }, [])

    useEffect(() => {
        if (featuredAdvisors.length > 0) {
            if (window.innerWidth >= 1800) {
                setAdvisors([featuredAdvisors.slice(0, 4), featuredAdvisors.slice(4, 8), featuredAdvisors.slice(8, 12)])
            } else if (((window.innerWidth > 1200) && (window.innerWidth < 1800))) {
                setAdvisors([featuredAdvisors.slice(0, 3), featuredAdvisors.slice(3, 6), featuredAdvisors.slice(6, 9), featuredAdvisors.slice(9, 12)])
            } else if ((window.innerWidth < 1200) && window.innerWidth > 820) {
                setAdvisors([featuredAdvisors.slice(0, 2), featuredAdvisors.slice(2, 4), featuredAdvisors.slice(4, 6), featuredAdvisors.slice(6, 8), featuredAdvisors.slice(8, 10), featuredAdvisors.slice(10, 12)])
            } else if (window.innerWidth <= 450) {
                setAdvisors(featuredAdvisors.map(advisor => [advisor]))
            }
        }
    }, [featuredAdvisors])

    async function fetchAdvisors() {
        const advisorResponse = await advisorProfileService.getMultiple(12);
        setFeaturedAdvisors(advisorResponse);
    }

    return (
        <>
            {loading && <div className='spinnerContainer'>
                <ClipLoader color={'var(--adfi_blue500)'} loading={loading} size={100} />
            </div>}
            {!loading && <div className={styles.pageContainer}>
                <div className={styles.contentContainer}>
                    <div className={styles.dashboardContainer}>
                        <div className={styles.dashboard}>
                            <Grid size={20} color="var(--adfi_blue400)" />
                            <h2>Dashboard</h2>
                        </div>
                        <div>
                            <Link to='/marketplace'><Button color="gradient-button" ><Search size={20} />Find Advisor</Button></Link>
                        </div>
                    </div>
                    <div className={styles.advisorsContainer}>
                        <div className={styles.advisorsSearch}>
                            <div className={styles.advisorsSearchDashboard}>
                                <h2 className={styles.featuredAdvisorsHeader}>Featured Advisors</h2>
                                <div className={styles.advisorsDashboardButtons}>
                                    <div className={styles.marketplaceButton}>
                                        <Link to='/marketplace'><Button color="clear-button"><ArrowRight size={20} />Marketplace</Button></Link>
                                    </div>
                                    <div className={styles.scrollButtons}>
                                        <Button color="clear-button grey" onClick={() => changeFeaturedAdvisors("-")}><ChevronLeft size={20} /></Button>
                                        <Button color="clear-button grey" onClick={() => changeFeaturedAdvisors("+")}><ChevronRight size={20} /></Button>
                                    </div>
                                </div>
                            </div>
                            {advisors.length > 0 && <div className={styles.advisorCardsContainer}>
                                {advisors[currentAdvisorsIndex].map((singleAdvisor, index) => (
                                    <AdvisorCard key={index} data={singleAdvisor} />
                                ))}
                            </div>
                            }
                        </div>
                    </div>
                    <div className={styles.accordionsContainer}>
                        <Accordion title={"Frequently Asked Questions"} icon={<HelpCircle size={20} color="grey" />} data={FAQ} />
                        <Accordion title={"Knowledge Base"} icon={<BookOpen size={20} color="grey" />} data={KnowledgeBase} />
                    </div>
                </div>
            </div>
            }
            {!loading && <GlobalFooter background={true} />}
        </>
    )
}

export default ConsumerDashboard
